import { TaggedError } from "@for-it/domain-lib";
export class PublicationNotFoundError extends TaggedError {
    constructor() {
        super("PublicationNotFoundError");
    }
}
